module.exports = __webpack_public_path__ + "img/Pellets-heizwert.9306281.webp";